import BuildingType from '@/roc/building/BuildingType';
import Effects from '@/roc/effects/Effects';
import ProductionCurrency from '@/roc/effects/Production/ProductionCurrency';
import ProductionOutputType from '@/roc/effects/Production/ProductionOutputType';
import ProductionQueue from '@/roc/effects/Production/ProductionQueue';
import ProductionWorkforce from '@/roc/effects/Production/ProductionWorkforce';
import ProductionCost from '@/roc/effects/Production/ProductionCost';
import ProductionDuration from '@/roc/effects/Production/ProductionDuration';
import ProductionOutput from '@/roc/effects/Production/ProductionOutput';

const TikiStatue = {
  id: '87',
  name: 'Tiki Statue',
  width: 2,
  height: 2,
  type: BuildingType.COLLECTABLE,
  era: 'stoneAge',
  icon: 'Tiki_Statue',
  minLevel: 1,
  maxLevel: 40,
  url: 'https://riseofcultures.wiki.gg/wiki/Buildings/Tiki_Statue',
  flags: 0,
  counts: null,
  effects: Effects.create([
    new ProductionQueue(
      ProductionWorkforce.asFlat(4),
      [
        ProductionCost.asFlat(5).withCurrency(ProductionCurrency.RESEARCH_POINTS),
      ],
      ProductionDuration.asHourMinutePerLevel([
        [16,  0], [15, 50], [15, 40], [15, 30], [15, 20],
        [15, 10], [15,  0], [14, 50], [14, 40], [14, 30],
        [14, 27], [14,  7], [13, 48], [13, 31], [13, 15],
        [13,  1], [12, 47], [12, 35], [12, 24], [12, 13],
        [12,  3], [11, 54], [11, 45], [11, 37], [11, 29],
        [11, 22], [11, 15], [11,  8], [11,  2], [10, 56],
        [10, 51], [10, 45], [10, 40], [10, 35], [10, 31],
        [10, 26], [10, 22], [10, 18], [10, 14], [10, 11],
      ]),
      ProductionOutput.asCallbackWithLevel(
        (level) => {
          return 150 + ((level - 1) * 30);
        }
      ).withOutput(ProductionOutputType.ALL_CURRENT_ERA_GOODS),
    ),
  ]),
};

export default TikiStatue;
